import script from "./ConsentFormDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsentFormDetail.vue?vue&type=script&setup=true&lang=js"

import "./ConsentFormDetail.vue?vue&type=style&index=0&id=c4906e44&lang=scss"
import "./ConsentFormDetail.vue?vue&type=style&index=1&id=c4906e44&scoped=true&lang=css"

import exportComponent from "/var/www/html/ccs-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4906e44"]])

export default __exports__